export default "__VITE_ASSET__Dm79fjkd__"